/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

import '@ot/shared/global-navigation-prod';
import { Environment } from '@ot/shared/utils';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

// bracket notation does not work with aot, e.g [IftaServiceName.FilingService]: `${iftaBaseUrl}/ifta-orchestration`
// https://angular.io/guide/aot-metadata-errors#expression-form-not-supported
export const environment: Environment = {
  baseUrl: '',
  appName: 'dashboard',
  production: false,
  serviceUrlList: {
    businessAccountService: `business-acct-service/v2`,
    vehicleService: `vehicle-service/v1`,
    userService: `user-service/v1`,
    taxAccountService: `tax-account-service/v2`,
    vehicleTaxAccountService: `vehicle-tax-account-service/v2`
  }
};
